/* eslint-disable max-len */
import * as types from './types';

export const getPersistence = (doneCallback) => ({
  type: types.GET_URL_PERSISTENT_CONFIGURATION,
  doneCallback,
});

/*
 * @param {any} action.configuration: the configuration you want to save
 */
export const updatePersistence = (action) => ({
  type: types.UPDATE_URL_PERSISTENT_CONFIGURATION,
  action,
});

export const deletePersistence = () => ({
  type: types.DELETE_URL_PERSISTENT_CONFIGURATION,
});

export const resetPersistence = (params = {}) => ({
  type: types.RESET_PERSISTENT_CONFIGURATION,
  params,
});

export const removeLoading = (persistenceKey) => ({
  type: types.SET_LOADING_FALSE,
  persistenceKey,
});

export const setActivePersistenceKey = (persistenceKey) => ({
  type: types.SET_PERSISTENCE_KEY,
  persistenceKey,
});
